module.exports = __webpack_public_path__ + "static/media/settings-icon.8416a0b9.svg";